import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import PublicLayout from "views/public/PublicLayout";
import Error from "views/ui-elements/Error";
const Home = Loadable(lazy(() => import("views/public")));
const AlbumsPage = Loadable(lazy(() => import("views/public/PublicAlbums")));
const CheckoutPage = Loadable(
  lazy(() => import("views/public/checkout/index"))
);
const LegalPage = Loadable(lazy(() => import("views/public/others/LegalPage")));
const TermsConditionsPage = Loadable(
  lazy(() => import("views/public/others/TermsConditionsPage"))
);
const RedirectToPhotographAlbum = Loadable(
  lazy(() => import("views/public/PublicAlbum/RedirectToPhotographAlbum"))
);
const GetOrder = Loadable(lazy(() => import("views/public/order")));

const VisitorRoutes = {
  path: "/",
  element: <PublicLayout />,
  children: [
    {
      path: "/",
      element: <AlbumsPage />,
    },
    {
      path: "/albums",
      element: <AlbumsPage />,
    },
    {
      path: "/albums/:id/*",
      element: <RedirectToPhotographAlbum />,
    },
    {
      path: "/checkout",
      element: <CheckoutPage />,
    },
    {
      path: "/order",
      element: <GetOrder />,
    },
    {
      path: "/legal",
      element: <LegalPage />,
    },
    {
      path: "/terms-conditions",
      element: <TermsConditionsPage />,
    },
    {
      path: "*",
      element: <Error />,
    },
  ],
};

export default VisitorRoutes;
